import angular from 'angular';
import addChangeEntityDialog from '../addChangeEntityDialog/addChangeEntityDialog';
import booksSvc from '../../../util/BooksSvc/BooksSvc';
import studentDialogContent from './addChangeStudentDialogContent.template.html';

export default angular.module("books.dialogs.entities.addChangeStudentDialog", [
  addChangeEntityDialog,
  booksSvc
  ])
  .service('AddChangeStudentDialog', addChangeStudentDialogService)
  .name;
  
  /*****************************************************************************
   * Service: AddChangeStudentDialog
   *
   * This returns an object that will display a modal dialog for managing a
   * student's information.
   *****************************************************************************/
  /* @ngInject */
    function addChangeStudentDialogService ($uibModal) {
    /*****************************************************************************
     * show */
    /**
     * Open a modal dialog to manage/create a student entity object.
     *
     * @param  id            Student ID to load. 0=New
     * @param  nameInput     Initial name to set for new students
     * @return               Promise object to listen for save success
     *****************************************************************************/
    this.show = function (id, nameInput) {
      return $uibModal.open({
        backdrop: 'static',
        bindToController: true,
        controllerAs: '$ctrl',
        controller: function ($scope, BooksSvc, SERVER) {
          var $ctrl = this;

          /** ID Length. */ $ctrl.MAX_CHARS_ID = 20;

          /*----------------------*/
          /* Set directive values */
          /*----------------------*/
          $ctrl.entityID = id;
          $ctrl.entityType = SERVER.BooksDBConstants.ET_STUDENT;
          $ctrl.nameInput = nameInput;

          /*-------------------------*/
          /* Service method wrappers */
          /*-------------------------*/
          $ctrl.getStudent = function () {
            return BooksSvc.getStudent(id);
          };
          $ctrl.saveStudent = function (student) {
            /*----------------------------------------*/
            /* Prevent null values for grade and exit */
            /* year from being sent to the service.   */
            /*----------------------------------------*/
            student.Grade = student.Grade || 0;
            student.exitYear = student.exitYear || 0;

            return BooksSvc.saveStudent(student);
          };

          /*****************************************************************************
           * setStudent */
          /**
           * Sets the student and ensures the grade and exit year are not null/undefined.
           *
           * @param  student     Source student entity object.
           *****************************************************************************/
          $ctrl.setStudent = function (student) {
            $ctrl.entity = student;

            if (!$ctrl.entity.Grade) $ctrl.entity.Grade = 0;
            if (!$ctrl.entity.exitYear) $ctrl.entity.exitYear = 0;
          };
        },
        template: studentDialogContent
      }).result;
    };
  };
